import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
import * as R from 'ramda'
import Page from '../../../component/page'
import CountryMap from '../CountryMap'
import CourseMap from '../../course/CourseMap'
import CourseTable from '../CourseTable'
import { isAdmin } from '../isAdmin'
import {
  filterAll,
  filterIsSmall,
  filterIsLarge,
  filterIsPrivate,
  filterIsActive,
  filterHasLocation,
  filterWrongHoleCount,
  filterIsZombieCourse,
  filterHasInvalidCountryAndState,
} from './../CourseFilters'

function numberWithSpaces(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

const percent = (tot, frac) => {
  return tot === 0 || frac === undefined
    ? 'Pending'
    : ((frac * 100) / tot).toFixed(2) + '%'
}

function AdminGroup(props) {
  const params = useParams()
  const dispatch = useDispatch()

  const { uniqeCoursesByName, isLoadingCourses } = props
  const [groupId, setGroupId] = useState(parseInt(params.groupId))
  const [courses, setCourses] = useState(
    props.courses.filter((c) => c.groupId === groupId)
  )
  const [courseFilter, setCourseFilter] = useState(filterAll)
  const [filteredCourses, setFilteredCourses] = useState(courses)
  const [selectedCourse, setSelectedCourse] = useState(null)
  const [selectedCountry, setSelectedCountry] = useState(null)
  const [selectedState, setSelectedState] = useState(null)

  const refreshData = () => {
    const { user, courses } = props
    const hasNoCourses = courses.length === 0
    const isNotLoadingCourses = !isLoadingCourses
    if (isAdmin(user) && hasNoCourses && isNotLoadingCourses) {
      dispatch({
        type: 'ADMIN_LOAD_ALL_COURSES',
        payload: {
          request: {
            url: `/admin/all`,
          },
        },
      })
    }
  }

  useEffect(() => {
    refreshData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.user, props.courses])

  useEffect(() => {
    const _courses = props.courses.filter((c) => c.groupId === groupId)
    const _filteredCourses = _courses.filter(courseFilter)
    console.log(
      'onCoursesChanged',
      groupId,
      props.courses.length,
      ' courses:',
      _courses.length,
      ' filteredCourses:',
      _filteredCourses
    )
    setCourses(_courses)
    setFilteredCourses(_filteredCourses)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.courses])

  const setFilter = (courseFilter) => {
    const _filteredCourses = courses.filter(courseFilter)
    setCourseFilter(courseFilter)
    setFilteredCourses(_filteredCourses)
  }

  const renderCourseFilterButton = (title, _courseFilter) => {
    const filteredCourses = courses.filter(_courseFilter)
    const filteredActive = filteredCourses.filter(filterIsActive)

    console.log(title, filteredCourses.length, 'Active', filteredActive.length)
    const className =
      'btn btn-small btn-' +
      (courseFilter === _courseFilter ? 'success' : 'primary')
    return (
      <div>
        <button onClick={() => setFilter(_courseFilter)} className={className}>
          <b>{title}:</b> {numberWithSpaces(filteredCourses.length)}
          {'  '}({percent(courses.length, filteredCourses.length)}){'  '}
          {numberWithSpaces(filteredActive.length)}
          {'  '}({percent(courses.length, filteredActive.length)})
        </button>
      </div>
    )
  }

  const renderFmtCourses = (title, filteredCourses) => {
    const filteredActive = filteredCourses.filter(filterIsActive)
    console.log(title, filteredCourses.length, 'Active', filteredActive.length)
    return (
      <div>
        <b>{title}:</b> {numberWithSpaces(filteredCourses.length)}
        {'  '}({percent(courses.length, filteredCourses.length)}){'  '}
        {numberWithSpaces(filteredActive.length)}
        {'  '}({percent(courses.length, filteredActive.length)})
      </div>
    )
  }

  if (!isAdmin(props.user)) return null

  const onClicked = (course, column) => {
    console.log(course, column)
    if (column === 'groupId') {
      setGroupId(course.groupId)
    } else if (column === 'country') {
      setSelectedCountry(course.country)
    } else if (column === 'state') {
      setSelectedState(course.state)
    } else {
      setSelectedCourse(null)
      setTimeout(() => setSelectedCourse(course), 1000)
    }
  }

  return (
    <>
      <Page className="container admin" hideAds>
        <div className="row">
          <div className="col-sm-12">
            <div>
              <h1>
                Admin for group: {groupId}{' '}
                {isLoadingCourses && ' is loading...'}
              </h1>
              {renderCourseFilterButton('All Courses', filterAll)}
              {renderCourseFilterButton('Active', filterIsActive)}
              {renderCourseFilterButton('Private', filterIsPrivate)}
              {renderCourseFilterButton(
                'Has invalid Country and State',
                filterHasInvalidCountryAndState
              )}
              {renderCourseFilterButton('With Location', filterHasLocation)}
              <span>&nbsp;</span>
              {renderCourseFilterButton(
                'Wrong hole count',
                filterWrongHoleCount
              )}
              {renderCourseFilterButton('Zombie', filterIsZombieCourse)}
              {renderCourseFilterButton('Small', filterIsSmall)}
              {renderCourseFilterButton('Large', filterIsLarge)}
              <span>&nbsp;</span>
              {renderFmtCourses('Unique by Name', uniqeCoursesByName)}
              {renderFmtCourses(
                'Unique by Name and Country',
                R.uniqBy(
                  (course) =>
                    (course.country || {}).name +
                    ':' +
                    course.name.toLowerCase(),
                  courses
                )
              )}
              <span>&nbsp;</span>
              {renderFmtCourses('Listed / Filtered Curses', filteredCourses)}
              {!!selectedCourse && (
                <button
                  className="btn btn-small btn-secondary"
                  onClick={() => setSelectedCourse(null)}
                >
                  Clear course: {selectedCourse.name}
                </button>
              )}
              {!!selectedCountry && (
                <button
                  className="btn btn-small btn-secondary"
                  onClick={() => setSelectedCountry(null)}
                >
                  Clear country: {selectedCountry.name}
                </button>
              )}
              {!!selectedState && (
                <button
                  className="btn btn-small btn-secondary"
                  onClick={() => setSelectedState(null)}
                >
                  Clear state: {selectedState.name}
                </button>
              )}
              <h2>Map</h2>
              {!selectedCourse && (
                <CountryMap
                  courses={filteredCourses}
                  country={selectedCountry}
                  state={selectedState}
                />
              )}
              {!!selectedCourse && <CourseMap course={selectedCourse} />}
              <h2>Courses</h2>
            </div>
          </div>
        </div>
      </Page>

      <CourseTable
        courses={filteredCourses}
        uniqeCoursesByName={uniqeCoursesByName}
        groupId={groupId}
        onClicked={onClicked}
        initialSort={[{ key: 'updated', order: 'desc' }]}
      />
    </>
  )
}

const mapStateToProps = (state) => {
  const { courses, uniqeCoursesByName, isLoadingCourses } = state.admin
  return {
    user: state.auth.user,
    courses,
    uniqeCoursesByName,
    isLoadingCourses,
  }
}

export default connect(mapStateToProps)(AdminGroup)
